import { CSSProperties } from 'react';
import { ActionIcon, Popover, Text } from '@mantine/core';
import { IconQuestionMark } from '@tabler/icons';

export default function HelpTooltip({
  text,
  size,
  style,
  width,
  className,
}: {
  text: string;
  size?: number;
  style?: CSSProperties;
  className?: string;
  width?: number;
}) {
  return (
    <div className={className} style={style}>
      <Popover width={width || 300} withArrow shadow="md">
        <Popover.Target>
          <ActionIcon size={size || 20} radius="xl" color="blue" variant="filled">
            <IconQuestionMark size="1rem" />
          </ActionIcon>
        </Popover.Target>
        <Popover.Dropdown>
          <Text size="sm">{text}</Text>
        </Popover.Dropdown>
      </Popover>
    </div>
  );
}
